let config

config = {
  platforms: [
    {
      name: 'boatvertizer',
      api: {
        url: 'https://api.boatvertizer.com/json/',
      },
      defaults: {
        language: 'en',
      },
    },
    {
      name: 'caravan24',
      api: {
        url: 'https://www.caravan24.ch/api/json/',
      },
      defaults: {
        language: 'chde',
      },
    },
  ],
}

export { config }
